import type { ReactNode } from 'react';

type Option<T extends string | number> = {
  value: T;
  label: string;
  icon?: ReactNode;
};

type Props<T extends string | number> = {
  options: Option<T>[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
};

export function SegmentedControl<T extends string | number>({
  options,
  value,
  onChange,
  className = '',
}: Props<T>) {
  return (
    <div className={`inline-flex bg-stone-100 rounded p-1 gap-1 ${className}`}>
      {options.map((opt) => {
        const isActive = opt.value === value;
        return (
          <button
            key={String(opt.value)}
            type="button"
            onClick={() => onChange(opt.value)}
            className={`flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-1 text-xs rounded transition-colors ${
              isActive
                ? 'bg-white shadow-sm font-semibold text-stone-900'
                : 'text-stone-600 hover:text-stone-900'
            }`}
          >
            {opt.icon}
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
